import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/taaltaal.webp';
import screenshot_target from '../../../images/letterfunnel/serhatsakarya.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Serhat Sakarya"
      firstname="Serhat"
      companyname="TaalTaal"
      competition="Kickstart School en Direct Dutch"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/serhatsakarya.js